import { Link } from "react-router-dom";
import {
  Instagram,
  Linkedin,
  Twitter,
  Youtube,
  MessageCircle,
  ArrowUpRight,
} from "lucide-react";
import { Reveal } from "./Reveal";

export default function Footer() {
  return (
    <footer className="relative bg-brand-bg border-t border-zinc-900 pt-10 lg:pt-10 pb-10 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-[1241px] mx-auto">

        


        {/* Footer Columns */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-10 border-t border-zinc-900 pt-10">
<div className="md:justify-self-center">
  <p className="eyebrow mb-4">
    Studio
  </p>
  <Link to="/" className="inline-block mb-2">
    <img
      src="https://dorado9-com-897128.hostingersite.com/wp-content/uploads/2025/08/White-and-Blue-Minimalist-Technology-Letter-D-Logo-7-e1770916697848.png"
      alt="Dorado9"
      className="h-[90px] w-auto"
    />
  </Link>

  

  <p className="text-zinc-400 text-sm leading-relaxed">
    Dorado9
    <br />
    Amritsar, India
    <br />
    hello@dorado9.com
    <br />
    +91 93560 20762
  </p>
</div>


          <div className="md:justify-self-center">
            <p className="eyebrow mb-4">
              Sitemap
            </p>

            <ul className="space-y-2 text-sm text-zinc-400">

              <li>
                <Link
                  to="/about"
                  className="hover:text-brand-mint transition-colors"
                >
                  About
                </Link>
              </li>

              <li>
                <Link
                  to="/services"
                  className="hover:text-brand-mint transition-colors"
                >
                  Services
                </Link>
              </li>

              <li>
                <Link
                  to="/portfolio"
                  className="hover:text-brand-mint transition-colors"
                >
                  Work
                </Link>
              </li>

              <li>
                <Link
                  to="/courses"
                  className="hover:text-brand-mint transition-colors"
                >
                  Courses
                </Link>
              </li>

              <li>
                <Link
                  to="/faq"
                  className="hover:text-brand-mint transition-colors"
                >
                  FAQ
                </Link>
              </li>

                            <li>
                <Link
                  to="/blog"
                  className="hover:text-brand-mint transition-colors"
                >
                  Blogs
                </Link>
              </li>

              <li>
                <Link
                  to="/contact"
                  className="hover:text-brand-mint transition-colors"
                >
                  Contact
                </Link>

              </li>

              <li>
                <Link
                  to="/privacy-policy"
                  className="hover:text-brand-mint transition-colors"
                >
                  Privacy Policy
                </Link>

              </li>

            </ul>
          </div>



          <div className="md:justify-self-center">
            <p className="eyebrow mb-4">
              Services
            </p>

            <ul className="space-y-2 text-sm text-zinc-400">
              <li><Link to="/services/seo" className="hover:text-brand-mint transition-colors">SEO</Link></li>
              <li><Link to="/services/paid-ads" className="hover:text-brand-mint transition-colors">Paid Ads</Link></li>
              <li><Link to="/services/social-media" className="hover:text-brand-mint transition-colors">Social Media</Link></li>
              <li><Link to="/services/whatsapp-marketing" className="hover:text-brand-mint transition-colors">WhatsApp</Link></li>
              <li><Link to="/services/web-and-app-development" className="hover:text-brand-mint transition-colors">Web & App</Link></li>
              <li><Link to="/services/graphic-design" className="hover:text-brand-mint transition-colors">Graphic Design</Link></li>
              <li><Link to="/services/email-marketing" className="hover:text-brand-mint transition-colors">Email</Link></li>
            </ul>
          </div>



          <div className="md:justify-self-center">
            <p className="eyebrow mb-4">
              Social
            </p>

            <ul className="space-y-3 text-sm text-zinc-400">

              <li>
                <a
                  href="https://instagram.com/the.dorado9"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 hover:text-brand-mint transition-colors"
                >
                  <Instagram size={14} />
                  @the.dorado9
                </a>
              </li>


              <li>
                <a
                  href="https://www.linkedin.com/company/dorado9"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 hover:text-brand-mint transition-colors"
                >
                  <Linkedin size={14} />
                  LinkedIn
                </a>
              </li>


              <li>
                <a
                  href="https://x.com/the_dorado9"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 hover:text-brand-mint transition-colors"
                >
                  <Twitter size={14} />
                  Twitter/X
                </a>
              </li>


              <li>
                <a
                  href="https://www.youtube.com/@the.Dorado9"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 hover:text-brand-mint transition-colors"
                >
                  <Youtube size={14} />
                  YouTube
                </a>
              </li>


              <li>
                <a
                  href="https://wa.me/919356020762"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-2 hover:text-brand-mint transition-colors"
                >
                  <MessageCircle size={14} />
                  WhatsApp
                </a>
              </li>

            </ul>
          </div>

        </div>



        {/* Bottom */}
        <div className="mt-12 border-t border-zinc-900 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">

          <p className="text-zinc-600 text-xs">
                    © {new Date().getFullYear()} Dorado9 Studio. All rights reserved.
          </p>

          <p className="text-zinc-600 text-xs">
            Designed with 💜 by <Link to="/" className="inline-block mb-">Dorado9.</Link>
          </p>


        </div>


      </div>
      
    </footer>
  );
}
